define("shared/components/shared/social/instagram-upgrade/banner", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _service, _component2, _tracking, _emberConcurrency, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if this.showBanner}}
    {{#if @isFullSize}}
      <div class="tIU--banner" data-test-id="ig-login-upgrade-full-banner" ...attributes>
        <div class="u--flex u--flex__row u--flex__alignItems--center">
          <img
            alt={{t "credentials.instagram_login_upgrade.banner.cta"}}
            class="tIU--banner__icon"
            src="/assets/images/img--instagramLoginUpgrade--icon.png"
          />
          <div class="u--flex u--flex__col u--flex__justify--center u--m__l__sm">
            <p class="u--text--bold u--m__b__xs">{{t "credentials.instagram_login_upgrade.banner.cta"}}</p>
            <p class="u--m__b__0">{{t "credentials.instagram_login_upgrade.banner.description"}}</p>
          </div>
        </div>
        <span>
          <Shared::Ui::Button
            @class="u--text--bold u--m__r__md"
            @onClick={{this.openModal}}
            @text={{t "shared_phrases.learn_more"}}
            @variant="actionLink"
            data-test-id="learn-more-button"
          />
          <Shared::Ui::Button
            @promise={{this.connect}}
            @text={{t "shared_words.connect"}}
            @variant="primary"
            data-test-id="connect-button"
          />
        </span>
      </div>
    {{else}}
      <div class="tIU--bannerNarrow" data-test-id="ig-login-upgrade-narrow-banner">
        <img
          alt={{t "credentials.instagram_login_upgrade.banner.cta"}}
          class="tIU--bannerNarrow__icon"
          src="/assets/images/img--instagramLoginUpgrade--icon.png"
        />
        <p class="u--m__b__0 u--m__lr__xs">{{t "credentials.instagram_login_upgrade.banner.cta"}}</p>
        <Shared::Ui::Button
          @class="u--text--bold"
          @onClick={{this.openModal}}
          @text={{t "shared_phrases.get_started"}}
          @variant="actionLink"
          data-test-id="get-started-button"
        />
      </div>
    {{/if}}
  {{/if}}
  
  {{#if (and this.canShowInstagramAuthStatus this.showInstagramAuthStatus)}}
    <Shared::Portal @destinationElement="root-portal">
      {{! @glint-expect-error: Shared::Credentials::InstagramAuthStatus }}
      <Shared::Credentials::InstagramAuthStatus
        @closeModal={{set this "showInstagramAuthStatus" false}}
        @socialProfile={{this.socialProfile}}
        @source={{this.sourcePage}}
      />
    </Shared::Portal>
  {{/if}}
  */
  {
    "id": "D38naoXK",
    "block": "[[[41,[30,0,[\"showBanner\"]],[[[41,[30,1],[[[1,\"    \"],[11,0],[24,0,\"tIU--banner\"],[24,\"data-test-id\",\"ig-login-upgrade-full-banner\"],[17,2],[12],[1,\"\\n      \"],[10,0],[14,0,\"u--flex u--flex__row u--flex__alignItems--center\"],[12],[1,\"\\n        \"],[10,\"img\"],[15,\"alt\",[28,[37,1],[\"credentials.instagram_login_upgrade.banner.cta\"],null]],[14,0,\"tIU--banner__icon\"],[14,\"src\",\"/assets/images/img--instagramLoginUpgrade--icon.png\"],[12],[13],[1,\"\\n        \"],[10,0],[14,0,\"u--flex u--flex__col u--flex__justify--center u--m__l__sm\"],[12],[1,\"\\n          \"],[10,2],[14,0,\"u--text--bold u--m__b__xs\"],[12],[1,[28,[35,1],[\"credentials.instagram_login_upgrade.banner.cta\"],null]],[13],[1,\"\\n          \"],[10,2],[14,0,\"u--m__b__0\"],[12],[1,[28,[35,1],[\"credentials.instagram_login_upgrade.banner.description\"],null]],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,1],[12],[1,\"\\n        \"],[8,[39,2],[[24,\"data-test-id\",\"learn-more-button\"]],[[\"@class\",\"@onClick\",\"@text\",\"@variant\"],[\"u--text--bold u--m__r__md\",[30,0,[\"openModal\"]],[28,[37,1],[\"shared_phrases.learn_more\"],null],\"actionLink\"]],null],[1,\"\\n        \"],[8,[39,2],[[24,\"data-test-id\",\"connect-button\"]],[[\"@promise\",\"@text\",\"@variant\"],[[30,0,[\"connect\"]],[28,[37,1],[\"shared_words.connect\"],null],\"primary\"]],null],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],[[[1,\"    \"],[10,0],[14,0,\"tIU--bannerNarrow\"],[14,\"data-test-id\",\"ig-login-upgrade-narrow-banner\"],[12],[1,\"\\n      \"],[10,\"img\"],[15,\"alt\",[28,[37,1],[\"credentials.instagram_login_upgrade.banner.cta\"],null]],[14,0,\"tIU--bannerNarrow__icon\"],[14,\"src\",\"/assets/images/img--instagramLoginUpgrade--icon.png\"],[12],[13],[1,\"\\n      \"],[10,2],[14,0,\"u--m__b__0 u--m__lr__xs\"],[12],[1,[28,[35,1],[\"credentials.instagram_login_upgrade.banner.cta\"],null]],[13],[1,\"\\n      \"],[8,[39,2],[[24,\"data-test-id\",\"get-started-button\"]],[[\"@class\",\"@onClick\",\"@text\",\"@variant\"],[\"u--text--bold\",[30,0,[\"openModal\"]],[28,[37,1],[\"shared_phrases.get_started\"],null],\"actionLink\"]],null],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]]]],[]],null],[1,\"\\n\"],[41,[28,[37,3],[[30,0,[\"canShowInstagramAuthStatus\"]],[30,0,[\"showInstagramAuthStatus\"]]],null],[[[1,\"  \"],[8,[39,4],null,[[\"@destinationElement\"],[\"root-portal\"]],[[\"default\"],[[[[1,\"\\n\"],[1,\"    \"],[8,[39,5],null,[[\"@closeModal\",\"@socialProfile\",\"@source\"],[[28,[37,6],[[30,0],\"showInstagramAuthStatus\",false],null],[30,0,[\"socialProfile\"]],[30,0,[\"sourcePage\"]]]],null],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[]],null]],[\"@isFullSize\",\"&attrs\"],false,[\"if\",\"t\",\"shared/ui/button\",\"and\",\"shared/portal\",\"shared/credentials/instagram-auth-status\",\"set\"]]",
    "moduleName": "shared/components/shared/social/instagram-upgrade/banner.hbs",
    "isStrictMode": false
  });
  let InstagramUpgradeBannerComponent = _exports.default = (_dec = (0, _service.inject)('social/instagram-auth'), (_class = class InstagramUpgradeBannerComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "intl", _descriptor2, this);
      _initializerDefineProperty(this, "instagramAuth", _descriptor3, this);
      _initializerDefineProperty(this, "router", _descriptor4, this);
      _initializerDefineProperty(this, "selectedSocialProfiles", _descriptor5, this);
      _initializerDefineProperty(this, "showInstagramAuthStatus", _descriptor6, this);
      _defineProperty(this, "connect", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          if (this.socialProfile) {
            yield this.instagramAuth.authenticateWithFacebookGraphApi.perform({
              refreshSocialProfiles: [this.socialProfile]
            });
            if (!this.instagramAuth.hasAllPermissions(this.socialProfile)) {
              this.alerts.alert(this.intl.t('account.controllers.groups.facebook.insufficient_permissions', {
                social_profile: this.socialProfile.nickname
              }));
            }
            if (this.socialProfile.needsRefresh) {
              this.instagramAuth.resetInstagramAuthStatusDates();
              this.showInstagramAuthStatus = true;
            }
          }
        }
      }), null, "connect", "drop"));
    }
    get canShowInstagramAuthStatus() {
      return this.instagramAuth.canShowInstagramAuthStatus;
    }
    get sourcePage() {
      return this.router.currentRouteName.split('.')[1];
    }
    get showBanner() {
      const hasProfileWithIgLogin = this.args.socialProfile ? this.args.socialProfile.isInstagramLogin : this.selectedSocialProfiles.profiles?.some(profile => profile.isInstagramLogin);
      return hasProfileWithIgLogin;
    }
    get socialProfile() {
      return this.args.socialProfile ?? this.selectedSocialProfiles.profiles.find(profile => profile.isInstagramLogin);
    }
    openModal() {
      this.instagramAuth.showInstagramUpgradeModal();
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "instagramAuth", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "selectedSocialProfiles", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "showInstagramAuthStatus", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "openModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "openModal"), _class.prototype)), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, InstagramUpgradeBannerComponent);
});